import React, { useContext } from 'react';

import { If } from 'utils';
import { UiKit } from 'components';
import { FeeConfig } from '../components';
import { useSegment } from 'utils/hooks';
import { AuthContext } from 'context/AuthContext';
import { useReturnProcessingFee } from './context';

export default function Form({ isDisabled = false }) {
  const { track } = useSegment();
  const { isExchangeAllowed } = useContext(AuthContext);
  const {
    data,
    errors,
    isError,
    isProcessing,
    onChange,
    onReload
  } = useReturnProcessingFee();

  const handleToggle = value => {
    track('FTU Wizard Fee Toggled', {
      fee_type: 'return_processing_fee',
      is_active: value
    });
    onChange({ is_active: value });
  };

  return (
    <FeeConfig
      title="Return Processing Fee"
      isActive={data.is_active}
      subtitle="Flat fee applied to each return or exchange."
      isError={isError}
      onReload={onReload}
      isDisabled={isDisabled}
      isProcessing={isProcessing}
      onToggle={handleToggle}
    >
      <UiKit.Grid gap="16">
        <UiKit.Input
          type="number"
          min={0}
          label="Return Fee"
          value={data.return_fee}
          onChange={value => onChange({ return_fee: value })}
          placeholder="Enter the fee amount"
          error={errors.return_fee}
          disabled={isDisabled}
          icon="$"
        />
        <If test={isExchangeAllowed}>
          <UiKit.Input
            type="number"
            min={0}
            label="Exchange Fee"
            value={data.exchange_fee}
            onChange={value => onChange({ exchange_fee: value })}
            placeholder="Enter the fee amount"
            error={errors.exchange_fee}
            disabled={isDisabled}
            icon="$"
          />
        </If>
      </UiKit.Grid>
    </FeeConfig>
  );
}
